

import React, { memo } from 'react';
import RequestProvider from '../../RequestProvider';
import { getResourceHistoryApi } from '../api';
import HistoryTabComponent from '../components/HistoryTab';










function HistoryTab({
  resourceId,
  resourceHistory,
  isV2Design,
  children,
  isInternalEventsVisible,
  editorId
}) {
  return (
    <RequestProvider
      requests={{ getResourceHistory: getResourceHistoryApi(resourceId || '') }}>

      {({ getResourceHistory }) =>
      <HistoryTabComponent
        getResourceHistory={getResourceHistory}
        isInternalEventsVisible={isInternalEventsVisible}
        resourceHistory={resourceHistory}
        isV2Design={isV2Design}
        editorId={editorId}>

          {children}
        </HistoryTabComponent>}

    </RequestProvider>);

}

export default memo(HistoryTab);